import React from "react";
import { Outlet } from "react-router-dom";

const Client: React.FC = () => {
  return <Outlet />;
};

export default Client;